import React, { PropsWithChildren, ReactElement } from 'react';

import { Button } from '@pb/shared/ui/atoms/old-button';
import { Icon } from '@pb/shared/ui/atoms/icon';
import { Card } from '@pb/shared/ui/atoms/card';
import { TSecondaryCalloutMessageProperties } from './secondary-callout-message.types';
import {
    StyledSecondaryCalloutMessageHeading,
    StyledSecondaryCalloutMessageIcon,
    StyledContentContainer,
    StyledWrapper,
} from './secondary-callout-message.styled';

export function SecondaryCalloutMessage({
    title,
    onClick,
    children,
    buttonTitle,
    icon = 'information',
    status = 'information',
    buttonColor = 'transparentBorderedIndigo',
    className,
    link,
}: PropsWithChildren<TSecondaryCalloutMessageProperties>): ReactElement {
    return (
        <Card className={className} showStyles={false}>
            <StyledWrapper
                status={status}
                data-testid="secondary-callout-message"
            >
                <StyledSecondaryCalloutMessageIcon>
                    <Icon type={icon} size={32} color="black" />
                </StyledSecondaryCalloutMessageIcon>
                <StyledContentContainer>
                    {title && (
                        <StyledSecondaryCalloutMessageHeading size="xxsmall">
                            {title}
                        </StyledSecondaryCalloutMessageHeading>
                    )}
                    {children}
                    {buttonTitle && (
                        <Button
                            to={link}
                            onClick={onClick}
                            fullWidthOnMobileOnly
                            color={buttonColor}
                        >
                            {buttonTitle}
                        </Button>
                    )}
                </StyledContentContainer>
            </StyledWrapper>
        </Card>
    );
}
